import React, { useRef, useEffect, useContext } from "react";
import classnames from "classnames";
import { Card, HTMLTable } from "@blueprintjs/core";
import { ViralAnnotationTableRow } from "./row";
import { StoresContext } from "../../pages/_app";
import { observer } from "mobx-react";

export const ViralAnnotationTable = observer(() => {
  const rootStore = useContext(StoresContext);
  const viralVariantStore = rootStore.viralVariantStore;
  const tableRef = useRef<HTMLTableSectionElement | null>(null);

  useEffect(() => {
    const idx = variantRows.findIndex(
      (v) => v.props.variant.uuid === viralVariantStore.selectedVariantUuid
    );
    jumpToRow(idx);
  }, [viralVariantStore.selectedVariant]);

  function jumpToRow(idx: number) {
    const table = tableRef.current;
    if (!table) {
      return;
    }
    table.scrollTop = 50 * idx;
    viralVariantStore!.tableJumpDone();
  }

  const variants = viralVariantStore.selectedVariantRun?.results || [];
  const variantRows = variants.map((variant, idx) => {
    return (
      <ViralAnnotationTableRow
        key={idx}
        variant={variant}
        selectVariant={(v) => viralVariantStore.selectVariant(v)}
      />
    );
  });

  function renderHeaders() {
    const classes = classnames("annotations-table__header");
    return (
      <thead className={classes}>
        <tr>
          <th>Segment</th>
          <th>Position</th>
          <th>Variant Type</th>
          <th>Reference</th>
          <th>Alternate</th>
          <th>Gene Name</th>
          <th>Gene Product</th>
          <th>Annotation Type</th>
          {viralVariantStore.canScroll && <th>Jump</th>}
          <th />
        </tr>
      </thead>
    );
  }

  return (
    <Card elevation={1}>
      <HTMLTable className="viral-variants-table" striped={true}>
        {renderHeaders()}
        <tbody className="annotations-table__body" ref={tableRef}>
          {variantRows}
        </tbody>
      </HTMLTable>
    </Card>
  );
});
